// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container matching Dashboard gradient */
.admin-approvals-container {
    min-height: 100vh;
    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);
    font-family: inherit;
    display: flex;
    flex-direction: column;
}

.center-content {
    justify-content: center;
    align-items: center;
}

.loading-text {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    color: #475569;
    font-weight: 500;
}

/* === HEADER === */
.groups-header {
    margin-bottom: 1.5rem;
}

.elder-back-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #cbd5e1;
    padding: 0.6rem 1rem;
    border-radius: 10px;
    font-size: 1rem;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.elder-back-btn:hover {
    background: #f1f5f9;
    border-color: #94a3b8;
    color: #1e293b;
}

.page-title {
    margin: 0;
    font-size: 1.5rem;
    color: #1e293b;
    font-weight: 800;
}

/* === MAIN CONTENT === */
.approvals-main-content {
    padding: 0 2rem 4rem 2rem;
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}

/* === CONTROL PANEL (Tabs & Search) === */
.approvals-control-panel {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 2rem;
    margin-bottom: 2.5rem;
    background: white;
    padding: 1rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.approvals-tabs {
    display: flex;
    gap: 0.5rem;
}

.tab-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.85rem 1.5rem;
    border: none;
    background: transparent;
    color: #64748b;
    font-size: 1.05rem;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.tab-btn:hover:not(.active) {
    background: #f1f5f9;
    color: #334155;
}

.tab-btn.active {
    background: #1e293b;
    color: white;
}

/* === NEW ISOLATED SEARCH BAR === */
.admin-search-form {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex: 1 1;
    max-width: 450px;
}

.admin-search-input-wrapper {
    display: flex;
    align-items: center;
    flex: 1 1;
    background: white;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    padding: 0 0.75rem;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.admin-search-input-wrapper:focus-within {
    border-color: #3b82f6;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.admin-search-icon {
    color: #94a3b8;
    flex-shrink: 0;
}

.admin-search-input {
    flex: 1 1;
    border: none;
    background: transparent;
    padding: 0.75rem 0.5rem;
    font-size: 1rem;
    color: #1e293b;
    outline: none;
    min-width: 0;
}

.admin-search-input::placeholder {
    color: #94a3b8;
}

.admin-search-submit-btn {
    background: #3b82f6;
    color: white;
    border: none;
    padding: 0.75rem 1.25rem;
    border-radius: 10px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
}

.admin-search-submit-btn:hover {
    background: #2563eb;
}

/* === LIST SECTION === */
.section-header-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
    gap: 0.75rem;
}

.elder-section-title {
    font-size: 1.4rem;
    color: #1e293b;
    font-weight: 700;
    margin: 0;
    padding-left: 0.25rem;
}

.total-count-badge {
    background: #f1f5f9;
    color: #475569;
    padding: 0.4rem 1rem;
    border-radius: 99px;
    font-weight: 700;
    font-size: 0.9rem;
    border: 1px solid #e2e8f0;
    white-space: nowrap;
}

.elder-list-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.approval-card {
    background: white;
    border-radius: 16px;
    padding: 1.5rem;
    border: 1px solid rgba(226, 232, 240, 0.8);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1.5rem;
}

/* Inside the strip card */
.list-card-left {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    flex: 1 1;
    min-width: 0;
}

.icon-wrapper {
    height: 56px;
    width: 56px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-slate {
    background: #f1f5f9;
    color: #475569;
}

.icon-navy {
    background: #e0e7ff;
    color: #3730a3;
}

.list-card-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1;
    min-width: 0;
}

.elder-card-title {
    margin: 0;
    font-size: 1.25rem;
    color: #1e293b;
    font-weight: 700;
    word-break: break-word;
}

.person-details-inline {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
}

.detail-text {
    font-size: 1.1rem;
    color: #334155;
    font-weight: 600;
}

.meta-info {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    color: #64748b;
    margin-top: 0.2rem;
}

/* === BUTTON STYLES (Matching Member Side) === */
.approval-actions {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    flex-shrink: 0;
}

.elder-btn-success-solid {
    background: #10b981;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}

.elder-btn-success-solid:hover:not(:disabled) {
    background: #059669;
}

.elder-btn-danger-solid {
    background: #ef4444;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}

.elder-btn-danger-solid:hover:not(:disabled) {
    background: #dc2626;
}

.elder-btn-danger-outline {
    background: white;
    color: #ef4444;
    border: 2px solid #fecaca;
    padding: 0.65rem 1.5rem;
    /* slightly less padding to account for border */
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.elder-btn-danger-outline:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #ef4444;
}

.elder-btn-secondary {
    background: white;
    color: #475569;
    border: 1px solid #cbd5e1;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.elder-btn-secondary:hover {
    background: #f1f5f9;
    color: #1e293b;
    border-color: #94a3b8;
}

.elder-btn-success-solid:disabled,
.elder-btn-danger-solid:disabled,
.elder-btn-danger-outline:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Empty States & Loading */
.elder-empty-card {
    background: white;
    border-radius: 16px;
    padding: 4rem 2rem;
    text-align: center;
    font-size: 1.2rem;
    color: #64748b;
    border: 2px dashed #cbd5e1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
}

.empty-icon-wrapper {
    height: 80px;
    width: 80px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

.sub-empty-text {
    font-size: 1rem;
    color: #94a3b8;
}

.elder-btn-primary {
    background: #2563eb;
    color: white;
    border: none;
    padding: 0.75rem 1.5rem;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
}

/* === MODAL STYLES === */
.elder-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.6);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 1rem;
}

.elder-modal-card {
    background: white;
    border-radius: 20px;
    padding: 2.5rem 2rem;
    max-width: 420px;
    width: 100%;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
    text-align: center;
    animation: scaleIn 0.2s ease-out;
    display: flex;
    flex-direction: column;
    align-items: center;
}

@keyframes scaleIn {
    from {
        transform: scale(0.95);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.modal-icon {
    height: 70px;
    width: 70px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.bg-green-light {
    background: #dcfce7;
}

.bg-red-light {
    background: #fee2e2;
}

.elder-modal-card h3 {
    margin: 0 0 1rem 0;
    color: #1e293b;
    font-size: 1.5rem;
    font-weight: 800;
}

.elder-modal-card p {
    color: #475569;
    font-size: 1.1rem;
    margin-bottom: 2rem;
    line-height: 1.5;
}

.elder-modal-actions {
    display: flex;
    gap: 1rem;
    width: 100%;
}

.elder-modal-actions button {
    flex: 1 1;
}

/* === PAGINATION === */
.elder-pagination {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 2rem;
    background: white;
    padding: 1rem 1.5rem;
    border-radius: 16px;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(226, 232, 240, 0.8);
}

.page-btn {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: #f1f5f9;
    border: none;
    color: #334155;
    padding: 0.75rem 1.25rem;
    border-radius: 12px;
    font-size: 1.1rem;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.2s;
}

.page-btn:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
}

.page-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.page-info {
    font-size: 1.1rem;
    color: #475569;
    font-weight: 600;
}

/* === RESPONSIVE FOR MOBILE === */
@media (max-width: 900px) {
    .approvals-control-panel {
        flex-direction: column;
        align-items: stretch;
        gap: 1.25rem;
    }

    .admin-search-form {
        max-width: 100%;
        width: 100%;
    }
}

@media (max-width: 768px) {
    .groups-header {
        padding: 1.25rem;
    }

    .approvals-main-content {
        padding: 0 1rem 3rem 1rem;
    }

    .approvals-tabs {
        flex-direction: column;
        width: 100%;
    }

    .tab-btn {
        width: 100%;
        justify-content: center;
        padding: 1rem;
    }

    .section-header-flex {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.75rem;
    }

    .approval-card {
        flex-direction: column;
        align-items: stretch;
        padding: 1.25rem;
        gap: 1.25rem;
    }

    .list-card-left {
        width: 100%;
        align-items: center;
    }

    .approval-actions {
        width: 100%;
        border-top: 1px solid #f1f5f9;
        padding-top: 1.25rem;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.75rem;
    }

    .elder-btn-success-solid,
    .elder-btn-danger-outline {
        justify-content: center;
        padding: 0.85rem;
    }

    .elder-modal-actions {
        flex-direction: column;
    }

    .elder-pagination {
        flex-direction: column;
        gap: 1.5rem;
    }

    .page-btn {
        width: 100%;
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .approval-actions {
        grid-template-columns: 1fr;
    }

    .admin-search-submit-btn {
        padding: 0.6rem 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/Approvals.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;IACI,iBAAiB;IACjB,6DAA6D;IAC7D,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,mBAAmB;AACnB;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAO;IACP,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,8CAA8C;IAC9C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA,iDAAiD;AACjD;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;IACvB,gDAAgD;IAChD,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,2BAA2B;AAC3B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;IACX,qFAAqF;IACrF,kBAAkB;IAClB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;IACI,SAAO;AACX;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,cAAc;IACd,wBAAwB;IACxB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA,kCAAkC;AAClC;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;QACvB,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,6BAA6B;QAC7B,oBAAoB;QACpB,aAAa;QACb,8BAA8B;QAC9B,YAAY;IAChB;;IAEA;;QAEI,uBAAuB;QACvB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/* Container matching Dashboard gradient */\n.admin-approvals-container {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #f8fafc 0%, #eef2f6 100%);\n    font-family: inherit;\n    display: flex;\n    flex-direction: column;\n}\n\n.center-content {\n    justify-content: center;\n    align-items: center;\n}\n\n.loading-text {\n    margin-top: 1.5rem;\n    font-size: 1.2rem;\n    color: #475569;\n    font-weight: 500;\n}\n\n/* === HEADER === */\n.groups-header {\n    margin-bottom: 1.5rem;\n}\n\n.elder-back-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: white;\n    border: 1px solid #cbd5e1;\n    padding: 0.6rem 1rem;\n    border-radius: 10px;\n    font-size: 1rem;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.elder-back-btn:hover {\n    background: #f1f5f9;\n    border-color: #94a3b8;\n    color: #1e293b;\n}\n\n.page-title {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #1e293b;\n    font-weight: 800;\n}\n\n/* === MAIN CONTENT === */\n.approvals-main-content {\n    padding: 0 2rem 4rem 2rem;\n    max-width: 1000px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* === CONTROL PANEL (Tabs & Search) === */\n.approvals-control-panel {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 2rem;\n    margin-bottom: 2.5rem;\n    background: white;\n    padding: 1rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.approvals-tabs {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.tab-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.85rem 1.5rem;\n    border: none;\n    background: transparent;\n    color: #64748b;\n    font-size: 1.05rem;\n    font-weight: 600;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.tab-btn:hover:not(.active) {\n    background: #f1f5f9;\n    color: #334155;\n}\n\n.tab-btn.active {\n    background: #1e293b;\n    color: white;\n}\n\n/* === NEW ISOLATED SEARCH BAR === */\n.admin-search-form {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex: 1;\n    max-width: 450px;\n}\n\n.admin-search-input-wrapper {\n    display: flex;\n    align-items: center;\n    flex: 1;\n    background: white;\n    border: 1px solid #cbd5e1;\n    border-radius: 10px;\n    padding: 0 0.75rem;\n    transition: border-color 0.2s, box-shadow 0.2s;\n}\n\n.admin-search-input-wrapper:focus-within {\n    border-color: #3b82f6;\n    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.admin-search-icon {\n    color: #94a3b8;\n    flex-shrink: 0;\n}\n\n.admin-search-input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    padding: 0.75rem 0.5rem;\n    font-size: 1rem;\n    color: #1e293b;\n    outline: none;\n    min-width: 0;\n}\n\n.admin-search-input::placeholder {\n    color: #94a3b8;\n}\n\n.admin-search-submit-btn {\n    background: #3b82f6;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.25rem;\n    border-radius: 10px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n    flex-shrink: 0;\n}\n\n.admin-search-submit-btn:hover {\n    background: #2563eb;\n}\n\n/* === LIST SECTION === */\n.section-header-flex {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 1.25rem;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n}\n\n.elder-section-title {\n    font-size: 1.4rem;\n    color: #1e293b;\n    font-weight: 700;\n    margin: 0;\n    padding-left: 0.25rem;\n}\n\n.total-count-badge {\n    background: #f1f5f9;\n    color: #475569;\n    padding: 0.4rem 1rem;\n    border-radius: 99px;\n    font-weight: 700;\n    font-size: 0.9rem;\n    border: 1px solid #e2e8f0;\n    white-space: nowrap;\n}\n\n.elder-list-container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.approval-card {\n    background: white;\n    border-radius: 16px;\n    padding: 1.5rem;\n    border: 1px solid rgba(226, 232, 240, 0.8);\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1.5rem;\n}\n\n/* Inside the strip card */\n.list-card-left {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.icon-wrapper {\n    height: 56px;\n    width: 56px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.icon-slate {\n    background: #f1f5f9;\n    color: #475569;\n}\n\n.icon-navy {\n    background: #e0e7ff;\n    color: #3730a3;\n}\n\n.list-card-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.35rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.elder-card-title {\n    margin: 0;\n    font-size: 1.25rem;\n    color: #1e293b;\n    font-weight: 700;\n    word-break: break-word;\n}\n\n.person-details-inline {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.detail-text {\n    font-size: 1.1rem;\n    color: #334155;\n    font-weight: 600;\n}\n\n.meta-info {\n    display: flex;\n    align-items: center;\n    font-size: 0.9rem;\n    color: #64748b;\n    margin-top: 0.2rem;\n}\n\n/* === BUTTON STYLES (Matching Member Side) === */\n.approval-actions {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    flex-shrink: 0;\n}\n\n.elder-btn-success-solid {\n    background: #10b981;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: background 0.2s;\n    white-space: nowrap;\n}\n\n.elder-btn-success-solid:hover:not(:disabled) {\n    background: #059669;\n}\n\n.elder-btn-danger-solid {\n    background: #ef4444;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: background 0.2s;\n    white-space: nowrap;\n}\n\n.elder-btn-danger-solid:hover:not(:disabled) {\n    background: #dc2626;\n}\n\n.elder-btn-danger-outline {\n    background: white;\n    color: #ef4444;\n    border: 2px solid #fecaca;\n    padding: 0.65rem 1.5rem;\n    /* slightly less padding to account for border */\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n}\n\n.elder-btn-danger-outline:hover:not(:disabled) {\n    background: #fef2f2;\n    border-color: #ef4444;\n}\n\n.elder-btn-secondary {\n    background: white;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.elder-btn-secondary:hover {\n    background: #f1f5f9;\n    color: #1e293b;\n    border-color: #94a3b8;\n}\n\n.elder-btn-success-solid:disabled,\n.elder-btn-danger-solid:disabled,\n.elder-btn-danger-outline:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* Empty States & Loading */\n.elder-empty-card {\n    background: white;\n    border-radius: 16px;\n    padding: 4rem 2rem;\n    text-align: center;\n    font-size: 1.2rem;\n    color: #64748b;\n    border: 2px dashed #cbd5e1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n}\n\n.empty-icon-wrapper {\n    height: 80px;\n    width: 80px;\n    border-radius: 20px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1rem;\n}\n\n.sub-empty-text {\n    font-size: 1rem;\n    color: #94a3b8;\n}\n\n.elder-btn-primary {\n    background: #2563eb;\n    color: white;\n    border: none;\n    padding: 0.75rem 1.5rem;\n    border-radius: 12px;\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n/* === MODAL STYLES === */\n.elder-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(15, 23, 42, 0.6);\n    backdrop-filter: blur(4px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 1rem;\n}\n\n.elder-modal-card {\n    background: white;\n    border-radius: 20px;\n    padding: 2.5rem 2rem;\n    max-width: 420px;\n    width: 100%;\n    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n    text-align: center;\n    animation: scaleIn 0.2s ease-out;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n@keyframes scaleIn {\n    from {\n        transform: scale(0.95);\n        opacity: 0;\n    }\n\n    to {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n.modal-icon {\n    height: 70px;\n    width: 70px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 1.5rem;\n}\n\n.bg-green-light {\n    background: #dcfce7;\n}\n\n.bg-red-light {\n    background: #fee2e2;\n}\n\n.elder-modal-card h3 {\n    margin: 0 0 1rem 0;\n    color: #1e293b;\n    font-size: 1.5rem;\n    font-weight: 800;\n}\n\n.elder-modal-card p {\n    color: #475569;\n    font-size: 1.1rem;\n    margin-bottom: 2rem;\n    line-height: 1.5;\n}\n\n.elder-modal-actions {\n    display: flex;\n    gap: 1rem;\n    width: 100%;\n}\n\n.elder-modal-actions button {\n    flex: 1;\n}\n\n/* === PAGINATION === */\n.elder-pagination {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 2rem;\n    background: white;\n    padding: 1rem 1.5rem;\n    border-radius: 16px;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);\n    border: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.page-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: #f1f5f9;\n    border: none;\n    color: #334155;\n    padding: 0.75rem 1.25rem;\n    border-radius: 12px;\n    font-size: 1.1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.page-btn:hover:not(:disabled) {\n    background: #e2e8f0;\n    color: #1e293b;\n}\n\n.page-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.page-info {\n    font-size: 1.1rem;\n    color: #475569;\n    font-weight: 600;\n}\n\n/* === RESPONSIVE FOR MOBILE === */\n@media (max-width: 900px) {\n    .approvals-control-panel {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 1.25rem;\n    }\n\n    .admin-search-form {\n        max-width: 100%;\n        width: 100%;\n    }\n}\n\n@media (max-width: 768px) {\n    .groups-header {\n        padding: 1.25rem;\n    }\n\n    .approvals-main-content {\n        padding: 0 1rem 3rem 1rem;\n    }\n\n    .approvals-tabs {\n        flex-direction: column;\n        width: 100%;\n    }\n\n    .tab-btn {\n        width: 100%;\n        justify-content: center;\n        padding: 1rem;\n    }\n\n    .section-header-flex {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0.75rem;\n    }\n\n    .approval-card {\n        flex-direction: column;\n        align-items: stretch;\n        padding: 1.25rem;\n        gap: 1.25rem;\n    }\n\n    .list-card-left {\n        width: 100%;\n        align-items: center;\n    }\n\n    .approval-actions {\n        width: 100%;\n        border-top: 1px solid #f1f5f9;\n        padding-top: 1.25rem;\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 0.75rem;\n    }\n\n    .elder-btn-success-solid,\n    .elder-btn-danger-outline {\n        justify-content: center;\n        padding: 0.85rem;\n    }\n\n    .elder-modal-actions {\n        flex-direction: column;\n    }\n\n    .elder-pagination {\n        flex-direction: column;\n        gap: 1.5rem;\n    }\n\n    .page-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n@media (max-width: 480px) {\n    .approval-actions {\n        grid-template-columns: 1fr;\n    }\n\n    .admin-search-submit-btn {\n        padding: 0.6rem 1rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
